<template>
    <div class="fourth">
        <div class="grid-list">
            <div class="grid-content">
                <div class="grid-item">
                    <span class="name">
                        会员
                    </span>
                    <span class="num">
                        {{ dataInfo.memberAmountRate }}%
                    </span>
                    <span class="name">
                        营业额占比
                    </span>
                </div>
                <div class="grid-item">
                    <span class="name">
                        非会员
                    </span>
                    <span class="num">
                        {{ dataInfo.notMemberAmountRate }}%
                    </span>
                </div>
            </div>
            <div class="grid-content">
                <div class="grid-item">
                    <span class="name">
                        会员营业额(元)
                    </span>
                    <span class="num">
                        {{ dataInfo.memberAmount }}
                    </span>
                    <span class="name">
                        折前人均 {{ dataInfo.memberAmountAvg }}
                    </span>
                </div>
            </div>
            <div class="grid-content">
                <div class="grid-item">
                    <span class="name">
                        非会员营业额(元)
                    </span>
                    <span class="num">
                        {{ dataInfo.notMemberAmount }}
                    </span>
                    <span class="name">
                        折前人均 {{ dataInfo.notMemberAmountAvg }}
                    </span>
                </div>
            </div>

        </div>
        <div class="card-list">
            <el-card class="card-box">
                <span class="title">
                    会员波动
                </span>
                <div>
                    <ul class="infinite-list">
                        <div class="card-item">
                            <div>
                                <i class="green el-icon-top"></i>
                                <span>新增会员</span>
                            </div>
                            <span>{{ dataInfo2.memberNum }}人</span>
                        </div>
                        <div class="card-item">
                            <div>
                                <i class="green el-icon-top"></i>
                                <span>新增会员卡</span>
                            </div>
                            <span>{{ dataInfo2.cardNum }}张</span>
                        </div>
                        <div class="card-item">
                            <div>
                                <i class="red el-icon-bottom"></i>
                                <span>退卡数</span>
                            </div>
                            <span>{{ dataInfo2.returnNum }}张</span>
                        </div>
                    </ul>
                </div>
            </el-card>
            <el-card class="card-box">
                <span class="title">
                    会员消费
                </span>
                <div>
                    <div class="no-scrollbar">
                        <div class="card-item">
                            <span>会员消费笔数</span>
                            <span>{{ dataInfo3.memberConsumeCount }}笔</span>
                        </div>
                        <div class="card-item">
                            <span>储值余额消费</span>
                            <span>{{ dataInfo3.cardConsumeAmount }}元</span>
                        </div>
                        <div class="card-item">
                            <span>赠送余额消费</span>
                            <span>{{ dataInfo3.presentConsumeAmount }}</span>
                        </div>
                        <div class="card-item">
                            <span>积分抵现变动</span>
                            <span>{{ dataInfo3.scoreConsumeChange }}积分</span>
                        </div>
                        <div class="card-item">
                            <span>积分抵扣余额</span>
                            <span>{{ dataInfo3.scoreBalanceChange }}元</span>
                        </div>
                        <div class="card-item">
                            <span>积分赠送变动</span>
                            <span>{{ dataInfo3.scorePresentChange }}积分</span>
                        </div>
                    </div>
                </div>
            </el-card>
            <!--    <el-card class="card-box">
                <span class="title">
                    会员消费（退）
                </span>
                <div>
                    <div style="overflow-y:scroll;height: 260px;">
                        <div class="card-item">
                            <span>卡消费金额</span>
                            <span>{{ dataInfo3.cardConsumeAmount }}元</span>
                        </div>

                    </div>
                </div>
            </el-card> -->
            <el-card class="card-box">
                <span class="title">
                    会员充值
                </span>
                <div>
                    <div class="no-scrollbar">
                        <div class="card-item">
                            <span>充值笔数</span>
                            <span>{{ dataInfo4.rechargeCount }}笔</span>
                        </div>
                        <div class="card-item">
                            <span>充值收款</span>
                            <span>{{ dataInfo4.rechargeAmount }}元</span>
                        </div>
                        <div class="card-item">
                            <span>储值余额变动</span>
                            <span>{{ dataInfo4.balanceChangeAmount }}</span>
                        </div>
                        <div class="card-item">
                            <span>赠送余额变动</span>
                            <span>{{ dataInfo4.presentChangeAmount }}</span>
                        </div>
                        <div class="card-item">
                            <span>积分赠送变动</span>
                            <span>{{ dataInfo4.scoreChangeAmount }}积分</span>
                        </div>

                    </div>
                </div>
            </el-card>
            <!--   <el-card class="card-box">
                <span class="title">
                    撤销会员充值
                </span>
                <div>
                    <div style="overflow-y:scroll;height: 260px;">
                        <div class="card-item">
                            <span>会员消费</span>
                            <span>1人</span>
                        </div>

                    </div>
                </div>
            </el-card> -->
            <el-card class="card-box">
                <span class="title">
                    会员退卡
                </span>
                <div>
                    <div class="no-scrollbar">

                        <div class="card-item">
                            <span>退卡笔数</span>
                            <span>{{ dataInfo5.rechargeCount }}笔</span>
                        </div>
                        <div class="card-item">
                            <span>退卡退款</span>
                            <span>{{ dataInfo5.rechargeAmount }}元</span>
                        </div>
                        <div class="card-item">
                            <span>储值余额变动</span>
                            <span>{{ dataInfo5.balanceChangeAmount }}</span>
                        </div>
                        <div class="card-item">
                            <span>赠送余额变动</span>
                            <span>{{ dataInfo5.presentChangeAmount }}</span>
                        </div>
                        <div class="card-item">
                            <span>积分变动</span>
                            <span>{{ dataInfo5.scoreChangeAmount }}积分</span>
                        </div>
                    </div>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        dateTime: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    data() {
        return {
            dataInfo: {},
            dataInfo2: {},
            dataInfo3: {},
            dataInfo4: {},
            dataInfo5: {}
        };
    },
    methods: {
        async getData() {

            let startTime = null
            let endTime = null
            if (this.dateTime.length > 0) {
                startTime = this.dateTime[0]
                endTime = this.dateTime[1]
            }
            let params = {
                startTime: startTime,
                endTime: endTime,
                merchantCode: localStorage.getItem('merchantCode')
            }
            let res = await this.$http.post('/businessOverview/customerStatistics', params)
            if (res.data.code == 200) {
                this.dataInfo = res.data.data
            }
            //会员波动
            let res2 = await this.$http.post('/businessOverview/customerChange', params)
            if (res2.data.code == 200) {
                this.dataInfo2 = res2.data.data
            }
            //会员消费
            let res3 = await this.$http.post('/businessOverview/customerConsume', params)
            if (res3.data.code == 200) {
                this.dataInfo3 = res3.data.data
            }
            //会员充值
            let res4 = await this.$http.post('/businessOverview/customerRecharge', params)
            if (res4.data.code == 200) {
                this.dataInfo4 = res4.data.data
            }
            //退卡
            let res5 = await this.$http.post('/businessOverview/customerReturnCard', params)
            if (res5.data.code == 200) {
                this.dataInfo5 = res5.data.data
            }
        }
    }
};
</script>

<style scoped lang="scss">
.fourth {
    width: 100%;
    background-color: #FFF;
    margin: 20px auto;

    .grid-list {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 20px;
        gap: 20px;
        width: 98%;

        .grid-content {
            flex: 1;
            display: flex;
            justify-content: start;
            align-items: center;
            height: 100px;
            border: 1px solid #ccc;
            border-radius: 5px;
            padding-left: 20px;

            .grid-item {
                display: flex;
                flex-direction: column;
                align-items: start;
                justify-content: start;
                gap: 5px;
                height: 70px;
                margin-right: 20px;

                .name {
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #666;
                }

                .num {
                    font-size: 20px;
                    font-weight: 500;
                    color: #222;
                }
            }

        }
    }

    .card-list {
        width: 98%;
        display: flex;
        align-items: center;
        justify-content: start;
        margin-top: 20px;
        gap: 20px;
        flex-wrap: wrap;

        .card-box {
            width: 32%;
            height: 360px;

            .title {
                font-size: 18px;
                color: rgba(0, 0, 0, .85);
                position: relative;
                margin-left: 10px;
            }

            .title::before {
                content: '';
                display: inline-block;
                width: 4px;
                height: 18px;
                background-color: #f59a23;
                position: absolute;
                left: -10px;
                top: 50%;
                transform: translateY(-50%);
            }

            .card-item {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 20px 0;
                border-bottom: 1px solid #e6e5e5;
            }
        }
    }
}

.green {
    color: #36db03da;
}

.red {
    color: #f00;
}

.no-scrollbar {
    overflow-y: auto;
    /* 启用垂直滚动 */
    height: 300px;
    padding-right: 20px;
}

/* 定义滚动条的样式 */
::-webkit-scrollbar {
    width: 12px;
    border-radius: 6px;
    /* 滚动条的宽度 */
}

/* 定义滚动条轨道的样式 */
::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 6px;
    /* 滚动条轨道的背景颜色 */
}

/* 定义滚动条的样式 */
::-webkit-scrollbar-thumb {
    background: #888;
    /* 滚动条的背景颜色 */
    border-radius: 6px;
    /* 滚动条的圆角 */
}

/* 当鼠标悬停在滚动条上时，改变滚动条的颜色 */
::-webkit-scrollbar-thumb:hover {
    background: #555;
    /* 滚动条的背景颜色 */
}
</style>